import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'ag1-loader',
  templateUrl: './ag1-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Ag1LoaderComponent {
  readonly classOverrides = input<string>('');
}
